// Tenant types whose data is scoped by accountingClient rather than store.
// Mirror of backend/utils/tenantType.js — keep both in sync.
export const ACCOUNTING_CLIENT_TENANT_TYPES = ['accounting_firm', 'billing', 'mrwd'];

export const isAccountingClient = (tenantType) =>
  ACCOUNTING_CLIENT_TENANT_TYPES.includes(tenantType);

export const getClientScope = (tenantType) =>
  isAccountingClient(tenantType) ? 'accountingClient' : 'store';